// Building category ID → label mapping
export const CATEGORY_MAP = {
  25: 'Residential',
  26: 'Commercial',
  27: 'Civic',
  28: 'Religious',
  29: 'Mixed',
};

// Building category ID → color for map styling
export const BUILDING_COLORS = {
  25: '#2196F3', // Blue - Residential
  26: '#FF9800', // Orange - Commercial
  27: '#9C27B0', // Purple - Civic
  28: '#4CAF50', // Green - Religious
  29: '#F44336', // Red - Mixed
};

// Boundary layer configuration
export const LAYER_CONFIG = [
  { key: 'island', color: '#810541', label: 'Islands' },
  { key: 'region', color: '#00008B', label: 'Regions' },
  { key: 'district', color: '#32CD32', label: 'Districts' },
  { key: 'shehia', color: '#8B8000', label: 'Shehia' },
  { key: 'zone', color: '#800000', label: 'Zones' },
];

// Deduplicated tile layer definitions
export const TILE_LAYERS = [
  { name: 'OpenStreetMap', url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', checked: false },
  { name: 'Google Roads', url: 'https://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}', checked: false },
  { name: 'Google Hybrid', url: 'https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}', checked: true },
  { name: 'Google Satellite', url: 'https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}', checked: false },
];
